import { render, staticRenderFns } from "./Activities.vue?vue&type=template&id=4c47178d&scoped=true&"
import script from "./Activities.vue?vue&type=script&lang=js&"
export * from "./Activities.vue?vue&type=script&lang=js&"
import style0 from "./Activities.vue?vue&type=style&index=0&id=4c47178d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c47178d",
  null
  
)

export default component.exports